import { useSearchParams } from 'next/navigation';

/**
 * True when the create-listing wizard is on the review step (`?step=review`).
 * On review, multiplex session APIs are skipped and listing endpoints are used instead.
 */
export const useIsOnReviewStep = (): boolean => {
  const searchParams = useSearchParams();
  return searchParams.get('step')?.toLowerCase() === 'review';
};
